import gql from 'graphql-tag';

export const removeCategoryMutation = gql`
  mutation removeCategory($categoryId: String!, $moveTo: String!) {
    removeCategory(categoryId: $categoryId, moveTo: $moveTo)
  }
`;
